import {generateInitialState} from "@/helpers/generateInitialState";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {healthProgrammesInitialState} from "../initialStates";
import {activateHealthProgramme, checkPost, loadAllHealthProgrammes, updatePostRating} from "./healthProgrammesActions";

const initialState = await generateInitialState("healthProgrammes", healthProgrammesInitialState);

const healthProgrammesSlice = createSlice({
  name: "healthProgrammes",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // builder
    //   .addMatcher(
    //     isAnyOf(
    //       activateHealthProgramme.pending,
    //       checkPost.pending,
    //       loadAllHealthProgrammes.pending,
    //       updatePostRating.pending,
    //     ),
    //     (state, action) => {
    //       state.isFetching = true;
    //       state.hasFailed = false;
    //     },
    //   )
    // .addMatcher(
    //   isAnyOf(
    //     activateHealthProgramme.rejected,
    //     checkPost.rejected,
    //     loadAllHealthProgrammes.rejected,
    //     updatePostRating.rejected,
    //   ),
    //   (state, action) => {
    //     const {message = "Something went wrong"} = action.payload || {};
    //     state.isFetching = false;
    //     state.hasFailed = true;
    //     state.errorMsg = message;
    //   },
    // )
    // .addMatcher(
    //   isAnyOf(
    //     activateHealthProgramme.fulfilled,
    //     checkPost.fulfilled,
    //     loadAllHealthProgrammes.fulfilled,
    //     updatePostRating.fulfilled,
    //   ),
    //   (state, action) => {
    //     console.log("action: ", action.payload);
    //     state.isFetching = false;
    //     state.hasFailed = false;
    //     state.errorMsg = "";
    //     state.data = [...action.payload];
    //   },
    // );
  },
});

export const {} = healthProgrammesSlice.actions;
export default healthProgrammesSlice.reducer;
